import React from 'react';
import './FeathersVideo.css';

interface FeathersVideoProps {
  videoSrc: string;
  posterImage?: string;
  autoPlay?: boolean;
}

const FeathersVideo: React.FC<FeathersVideoProps> = ({ 
  videoSrc, 
  posterImage,
  autoPlay = true 
}) => {
  return (
    <section className="feathers-video">
      <video 
        src={videoSrc} 
        poster={posterImage}
        autoPlay={autoPlay}
        muted 
        loop 
        playsInline
      />
    </section>
  );
};

export default FeathersVideo;